import React, { PropsWithChildren, ReactElement } from 'react'

import globalState from 'store/global/global'

import { useSnapshot } from 'valtio'

import NotificationCenter from '../NotificationCenter/NotificationCenter'
import Sidebar from './components/Sidebar/Sidebar'
import Topbar from './components/Topbar/Topbar'
import styles from './Navigation.module.less'
import { RoutesArray } from './types'

export type NavigationProps = PropsWithChildren<{
  routes: RoutesArray
}>

export default function Navigation({ routes, children }: PropsWithChildren<NavigationProps>): ReactElement {
  const globalSnap = useSnapshot(globalState)
  return (
    <>
      <Topbar
        desktopDrawerOpen={globalSnap.navigationIsOpen}
        setDesktopDrawerOpen={(navigationIsOpen) => {
          globalState.navigationIsOpen = navigationIsOpen
        }}
        mobileDrawerOpen={globalSnap.navigationMobileOpen}
        setMobileDrawerOpen={(navigationMobileOpen) => {
          globalState.navigationMobileOpen = navigationMobileOpen
        }}
        notificationCenterOpen={globalSnap.notificationCenterIsOpen}
        setNotificationCenterOpen={(notificationCenterOpen) => {
          globalState.notificationCenterIsOpen = notificationCenterOpen
        }}
      />
      <Sidebar
        desktopDrawerOpen={globalSnap.navigationIsOpen}
        mobileDrawerOpen={globalSnap.navigationMobileOpen}
        routes={routes}
        setMobileDrawerOpen={(navigationMobileOpen) => {
          globalState.navigationMobileOpen = navigationMobileOpen
        }}
      />
      <main className={styles.content}>
        <div className={styles.toolbar} />
        {children}
      </main>
      {globalSnap.notificationCenterIsOpen && <NotificationCenter />}
    </>
  )
}
